import Carousel from 'nuka-carousel';
import styled from 'styled-components';

export const Container = styled(Carousel)`
    padding-bottom: 2rem;
    width: 100%;
`;
